var map = {
	"./level1.json": 219,
	"./level2.json": 330,
	"./level3.json": 773,
	"./level4.json": 716,
	"./level5.json": 799,
	"./level6.json": 438,
	"./level7.json": 145,
	"./level8.json": 488,
	"./level9.json": 995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;